import styled, { keyframes } from "styled-components";
import { paletas } from "../../styles/theme";

type StylesProp = {
  cor: any;
};

const animaMensagem = keyframes`
    0% {
        opacity: 0;
        margin-left: 0px;
    }
    10% {
        opacity: 1;
        margin-left: 20px;
    }
    95% {
        opacity: 1;
        margin-left: 20px;
    }
    100% {
        opacity: 0;
        margin-left: 0px;
    }
`;

export const Wrapper = styled.div<StylesProp>`
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0;
  margin-bottom: 20px;
  border: none;
  border-radius: 0.25rem;
  padding: 20px;
  color: ${paletas.White};
  background-color: ${(props) => props.cor};
  transition: all 0.25s;
  animation: 5s ${animaMensagem} ease-in-out;
`;
